import * as React from 'react'

import { History } from 'history'
import Cookies from 'universal-cookie'

import './App.css'

import Core from './Core'
import Modal from './Modal/Modal'
import { ToolInstance } from './ToolInstance';


declare const drift: any;

interface IAppProps {
    history: any
}

class App extends React.Component<IAppProps> {
    private modalRef: any;

    public constructor(props: IAppProps) {
        super(props);

        this.modalRef = React.createRef();
    }

    public componentWillMount() {
        const cookies = new Cookies();
        const idToken = cookies.get('id_token');

        if(!idToken) {
            ((this.props as any).history as History).push("/login");
        }        
    }

    public componentDidMount() {
        const cookies = new Cookies();
        const name = cookies.get('name');
        const email = cookies.get('email');

        drift.load('7es7ec7v8udf');
        /* does not require drift to be loaded already */
        drift.identify(email, { "name": name, "email": email });

        drift.on("ready", (api:any) => {
            api.widget.show();
        });

        this.forceUpdate();
    }

    public render() {
        return (
            <div className="App">
                <Modal ref={this.modalRef} />

                <Core openModal={this.openModal} onSignOutRequested={this.signOutRequested} />
            </div>
        );
    }

    private openModal = (toolInstance: ToolInstance) => {
        this.modalRef.current.open(toolInstance);
    };

    private signOutRequested = () => {
        const cookies = new Cookies();
        cookies.remove("id_token");

        this.props.history.push("/login");
    }
};

export default App;


// WEBPACK FOOTER //
// ./src/App/App.tsx